<script>
import { mapGetters } from 'vuex';
import SavePresetModal from './SavePresetModal.vue';
import SignupModal from './SignupModal.vue';

export default {
  name: 'PopupModalWrap',
  components: {
    SavePresetModal,
    SignupModal,
  },
  props: {
    env: {
      type: String,
      default: () => 'prod',
      validator: value => {
        return ['prod', 'dev', 'staging'].indexOf(value) !== -1;
      },
    },
    returnUrl: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'Predictor/getLogInStatus',
    }),
  },
};
</script>

<template>
  <div class="popup-modal-wrap">
    <div v-if="isLoggedIn" class="save-preset-modal popup-modal__content">
      <SavePresetModal :env="env" />
    </div>
    <div v-if="!isLoggedIn" class="sign-up-modal popup-modal__content">
      <SignupModal :return-url="returnUrl" />
    </div>
  </div>
</template>
